<template>
  <figure style="width: 100%; height: 100%;display: flex;align-items: center;justify-content: center;">
    <chart :options="pieOptions" @click="tweetTypeFilter" style='width: 100%; height: 100%' ref="pie" auto-resize v-if="dataState === 'ready'"></chart>
    <template v-else-if="dataState === 'loading'">
      <center>
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </center>
    </template>
    <template v-else-if="dataState === 'noData'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
    </template>
    <template v-else-if="dataState === 'error'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
    </template>
  </figure>
</template>

<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      pieOptions: {
        tooltip: {trigger: 'item', formatter: '{a} <br/>{b} : {c} ({d}%)'},
        series: [{
          name: 'Tweets Types',
          type: 'pie',
          data: [
            {value: 0, name: 'Tweets'},
            {value: 0, name: 'Retweets'},
            {value: 0, name: 'Reply Tweets'},
            {value: 0, name: 'Quote Tweets'}
          ]
        }]
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getTweetType', 'getQuery']),
    filterTweetType: function () {
      return this.getTweetType
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setCustomFilters', 'resetTweetTypeFilter']),
    tweetTypeFilter: function (type) {
      if (type) {
        if (type.name === 'Tweets') {
          type = 'TWEET'
        } else if (type.name === 'Retweets') {
          type = 'RETWEET'
        } else if (type.name === 'Quote Tweets') {
          type = 'QUOTE_TWEET'
        } else if (type.name === 'Reply Tweets') {
          type = 'REPLY_TWEET'
        }
        var filter = this.filterTweetType.slice()
        var index = filter.indexOf(type)
        if (index >= 0) {
          filter.splice(index, 1)
          this.setCustomFilters({tweetType: filter})
        } else {
          filter.push(type)
          this.setCustomFilters({tweetType: filter})
        }
      }
    },
    getData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getTweetsTypesCount', this.getQuery({}))
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          this.pieOptions.series = []
          var tweets = r1.data.payload.find(function (element) { return element._tweet_type === 'TWEET' })._tweet_count
          var retweets = r1.data.payload.find(function (element) { return element._tweet_type === 'RETWEET' })._tweet_count
          var replyTweets = r1.data.payload.find(function (element) { return element._tweet_type === 'REPLY_TWEET' })._tweet_count
          var quoteTweets = r1.data.payload.find(function (element) { return element._tweet_type === 'QUOTE_TWEET' })._tweet_count
          this.pieOptions.series.push({
            name: 'Tweets Types',
            type: 'pie',
            data: [
              {value: tweets, name: 'Tweets'},
              {value: retweets, name: 'Retweets'},
              {value: replyTweets, name: 'Reply Tweets'},
              {value: quoteTweets, name: 'Quote Tweets'}
            ]
          })
          if (tweets === 0 && retweets === 0 && replyTweets === 0 && quoteTweets === 0) {
            this.dataState = 'noData'
          } else {
            this.dataState = 'ready'
          }
        } else {
          this.dataState = 'error'
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (!underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.getData()
        }
      }
    },
    loading: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal === true) {
          let pie = this.$refs.pie
          if (pie) {
            pie.showLoading({
              text: '',
              color: '#4ea397',
              maskColor: 'rgba(255, 255, 255, 0.4)'
            })
          }
        } else {
          let pie = this.$refs.pie
          if (pie) {
            pie.hideLoading()
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/TweetsTypesPieChart.vue